import { Component, AfterViewInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-setting-game',
  templateUrl: './setting-game.component.html',
  styleUrls: ['./setting-game.component.scss']
})
export class SettingGameComponent implements AfterViewInit {
  public company_uuid;
  public games: any[] = [];
  public overwrite: any = {
    from_game_uuid: '',
    to_game_uuid: '',
    date_from: '',
    date_to: '',
    include_player_ids: false,
    note: ''
  };
  public overwrite_preview: any = null;
  public is_previewing = false;
  public is_overwriting = false;
  private table_setting: any;

  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService, private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
   }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/setting/game/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Title', type: 'string', key: 'title', filter: 'string'}, 
          {label: 'Status', type: 'status', key: 'status', filter: 'status'}, 
          {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/setting-game/form', hide: true},
          {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_game', title: 'title', hide: true},
        ]}
    this.table_setting = setting;
    this.tb.init(setting);
    this.loadGames();
    this.cdr.detectChanges();
  }

  async loadGames() {
    const games: any = await this.http.post('/admin/setting/game/get');
    this.games = Array.isArray(games) ? games : [];
  }

  async previewOverwrite() {
    if (!this.overwrite.from_game_uuid || !this.overwrite.to_game_uuid) {
      alert('Select source game and target game.');
      return;
    }

    this.is_previewing = true;
    this.overwrite_preview = await this.http.post('/admin/setting/game/overwrite/preview', this.overwrite);
    this.is_previewing = false;
  }

  async applyOverwrite() {
    if (!this.overwrite_preview || !this.overwrite_preview.summary) {
      await this.previewOverwrite();
    }

    const rows = this.overwrite_preview && this.overwrite_preview.summary ? this.overwrite_preview.summary.rows_count : 0;
    const fromTitle = this.overwrite_preview && this.overwrite_preview.from_game ? this.overwrite_preview.from_game.title : 'source game';
    const toTitle = this.overwrite_preview && this.overwrite_preview.to_game ? this.overwrite_preview.to_game.title : 'target game';
    const confirmed = window.confirm(`Overwrite ${rows} sales rows from "${fromTitle}" to "${toTitle}"?`);

    if (!confirmed) {
      return;
    }

    this.is_overwriting = true;
    const result: any = await this.http.post('/admin/setting/game/overwrite/update', this.overwrite);
    this.is_overwriting = false;

    if (result && result.status) {
      this.overwrite_preview = null;
      await this.loadGames();
      this.tb.init(this.table_setting);
    }
  }

}
